import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./action";
import mutations from "./mutations";
Vue.use(Vuex);

const state = {
  changedrawer: false,
  refreshtoken: "",
  accesstoken: "",
  authen: "",
  profile: {},
  centresso: false,
  status: "processing",
  send_mail_item: {},
  // refreshtoken_payment: '',
  // authenpayment: false
  apikey:
    "AK2-3UY8R84Q6GFXD8QXZMFYNPUJRFOKWOT614C5GAAC88OVAGLD8F1HWAPB9LW05QQSACKVSN0FBI1H8WPO0NWU29MWO9854BBMW5OJ6IZOBUJFZRHV0ZPD4CP02PXLT95YHD6QX3TH01CZX7TJ7X4NBLKZLGQP8NF3BKZIU6NSW463VL61A8LBBAKIJSQS7M1TL2S50E6AGWRE85ZSK6AIHYDYXY7C19LKLFRFWXW3FAOAB61O0E5TGPBNC3P4X72BU",
  accessKey: "p@ss2020",
  A_M_store: "Auto",
  menu: [],
  defaultMenu: [
    [
      {
        child: [],
        disable: false,
        group: false,
        icon: "mdi-home-outline",
        name: "home",
        no: 0,
        path: "/portal/profile",
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.home"
      },
      {
        child: [],
        disable: false,
        group: false,
        icon: "mdi-account-settings-outline",
        name: "profile",
        no: 1,
        path: "/portal/profile",
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "profile.title"
      },
      {
        child: [
          {
            disable: false,
            group: true,
            icon: "mdi-file-chart-outline",
            list: [
              {
                disable: false,
                group: true,
                icon: "mdi-view-dashboard-outline",
                name: "dashboard",
                no_list: 1,
                path: "/portal/dashboard",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.dashbord",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-clipboard-text-multiple-outline",
                name: "report",
                no: 2,
                no_list: 2,
                path: "/portal/report",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.report",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-card-bulleted-settings-outline",
                name: "reportsetting",
                no: 3,
                no_list: 3,
                path: "/portal/reportsetting",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.report_setting",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-text-box-search-outline",
                name: "searchdocument",
                no: 4,
                no_list: 4,
                path: "/portal/searchdocument",
                role_access: ["owner", "etax-admin", "etax-user", "user"],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.search_documents",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-text-box-check-outline",
                name: "reportinstead",
                no: 5,
                no_list: 5,
                path: "/portal/reportinstead",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.instead",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-database-search-outline",
                name: "processlog",
                no_list: 6,
                path: "/portal/processlog",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.log",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-email-check-outline",
                name: "mailrelayreport",
                no_list: 7,
                path: "/portal/mailrelayreport",
                role_access: ["owner", "etax-admin", "etax-user", "user"],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.email",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-earth",
                name: "ocr",
                no_list: 8,
                path: "/portal/ocr",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.ocr",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-delete-variant",
                name: "deleteTransaction",
                no_list: 9,
                path: "/portal/delete_transaction",
                role_access: ["owner", "etax-admin", "etax-user", "user"],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.delete_transaction",
                type: ""
              }
            ],
            model: true,
            name: "full",
            no_child: 1,
            path: "/portal/dashbord",
            role_access: [
              "owner",
              "etax-admin",
              "etax-user",
              "etax-bd",
              "user"
            ],
            taxid_access: [],
            text: "portaltoolbar.etax_invoice.full"
          },
          {
            disable: false,
            group: true,
            icon: "mdi-text-box-outline ",
            list: [
              {
                disable: true,
                icon: "mdi-view-dashboard-outline",
                name: "dashboardabb",
                no: 1,
                no_list: 1,
                path: "/portal/dashboardabb",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: true,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.dashbord",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-clipboard-text-multiple-outline",
                name: "reportabb",
                no_list: 2,
                path: "/portal/reportabb",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: false,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.report",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-card-bulleted-settings-outline",
                name: "reportsettingabb",
                no_list: 3,
                path: "/portal/reportsettingabb",
                role_access: [
                  "owner",
                  "etax-admin",
                  "etax-user",
                  "etax-bd",
                  "user"
                ],
                status: false,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.report_setting",
                type: ""
              },
              {
                disable: false,
                icon: "mdi-file-search-outline",
                name: "searchdocumentabb",
                no_list: 4,
                path: "/portal/searchdocumentabb",
                role_access: ["owner", "etax-admin", "etax-user", "user"],
                status: false,
                taxid_access: [],
                text: "portaltoolbar.etax_invoice.search_documents",
                type: ""
              }
            ],
            model: true,
            name: "abb",
            no_child: 2,
            path: "/portal/inspection_report",
            role_access: [
              "owner",
              "etax-admin",
              "etax-user",
              "etax-bd",
              "user"
            ],
            taxid_access: [],
            text: "portaltoolbar.etax_invoice.abb"
          }
        ],
        group: true,
        icon: "mdi-grid",
        "icon-alt": "mdi-chevron-down",
        model: true,
        name: "service",
        no: 2,
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.service"
      },
      {
        child: [
          {
            disable: false,
            icon: "mdi-barcode",
            list: [],
            name: "searchRevenue",
            no_child: 1,
            path: "/portal/web_portal_searchRevenue",
            role_access: ["owner", "etax-admin", "etax-user", "user"],
            status: false,
            taxid_access: [],
            text: "portaltoolbar.etax_invoice.revenue",
            type: ""
          },
          {
            disable: false,
            icon: "mdi-file-find",
            list: [],
            name: "statusRevenue",
            no_child: 2,
            path: "/portal/web_portal_Revenue_status",
            role_access: ["owner", "etax-admin", "etax-user", "user"],
            status: false,
            taxid_access: [],
            text: "portaltoolbar.etax_invoice.revenue_status",
            type: ""
          },
          {
            disable: false,
            icon: "mdi-file-find",
            list: [],
            name: "revenueByone",
            no_child: 3,
            path: "/portal/web_portal_Revenue_byone",
            role_access: ["owner", "etax-admin", "etax-user", "user"],
            status: false,
            taxid_access: [],
            text: "portaltoolbar.etax_invoice.sentRevenuebyone",
            type: ""
          }
        ],
        disable: false,
        group: true,
        icon: "mdi-bank-outline",
        name: "revenue",
        no: 3,
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.etax_invoice.title_revenue"
      },
      {
        child: [
          {
            no_child: 1,
            name: "logsSystemUsage",
            icon: "mdi-remote-desktop",
            text: "portaltoolbar.logsusage",
            path: "/portal/logs_system_usage",
            type: "",
            list: [],
            status: false,
            disable: false,
            role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
            taxid_access: []
          },
          {
            no_child: 2,
            name: "logsPrintDocument",
            icon: "mdi-monitor",
            text: "portaltoolbar.logsprintdocument",
            path: "/portal/logs_print_document",
            type: "",
            list: [],
            status: false,
            disable: false,
            role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
            taxid_access: []
          },
        ],
        disable: false,
        group: true,
        icon: "mdi-account-network",
        name: "admin",
        no: 4,
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.admin.title",
      },
      {
        child: [],
        disable: false,
        group: false,
        icon: "mdi-remote-desktop",
        name: "logsSystemUsage",
        no: 5,
        path: "/portal/logs_system_usage",
        role_access: ["owner", "etax-admin"],
        taxid_access: ["0105551019496"],
        text: "portaltoolbar.logsusage"
      },
      {
        child: [
          {
            disable: false,
            group: false,
            icon: "mdi-card-plus-outline",
            list: [],
            name: "createBill",
            no_child: 1,
            path: "/portal/create_bill_index",
            role_access: [
              "owner",
              "etax-admin",
              "etax-user",
              "etax-bd",
              "user"
            ],
            taxid_access: [],
            text: "portaltoolbar.bill.create_etax"
          },
          {
            no_child: 2,
            name: "editTaxInvoice",
            icon: "mdi-text-box-check-outline",
            text: "portaltoolbar.bill.editTaxInvoice",
            path: "/portal/edit_cancel_document",
            group: false,
            disable: false,
            list: [],
            role_access: [
              "owner",
              "etax-admin",
              "etax-user",
              "etax-bd",
              "user"
            ],
            taxid_access: []
          },
          {
            disable: false,
            group: false,
            icon: "mdi-text-box-plus-outline",
            list: [],
            name: "runningNumber",
            no_child: 3,
            path: "/portal/running_number_index",
            role_access: [
              "owner",
              "etax-admin",
              "etax-user",
              "etax-bd",
              "user"
            ],
            taxid_access: [],
            text: "portaltoolbar.bill.setting_number"
          }
        ],
        disable: false,
        group: true,
        icon: "mdi-credit-card-plus-outline",
        name: "bill",
        no: 6,
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.bill.title"
      },
      {
        child: [
          {
            disable: false,
            group: false,
            icon: "mdi-monitor-multiple",
            list: [],
            name: "open_api_create_etax",
            no_child: 1,
            path: "/portal/open-api-create-etax",
            role_access: ["owner", "etax-admin"],
            taxid_access: [
              "0105551019496",
              "0125548007288",
              "0205562006977",
              "0105561072420"
            ],
            text: "portaltoolbar.bill.create_etax"
          }
        ],
        disable: false,
        group: true,
        icon: "mdi-note-outline",
        name: "openAPI",
        no: 7,
        role_access: ["owner", "etax-admin"],
        taxid_access: [
          "0105551019496",
          "0125548007288",
          "0205562006977",
          "0105561072420"
        ],
        text: "OPEN API"
      },
      {
        child: [],
        disable: false,
        group: false,
        icon: "mdi-file-document-edit-outline",
        name: "sftp_confirm",
        no: 8,
        path: "/portal/sftp_confirm_index",
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "portaltoolbar.sftp_confirm"
      },
      {
        child: [],
        disable: false,
        group: false,
        icon: "mdi-folder-cog-outline",
        name: "sftp",
        no: 9,
        path: "/portal/sftp-ftp/login",
        role_access: ["owner", "etax-admin", "etax-user", "etax-bd", "user"],
        taxid_access: [],
        text: "SFTP-FTP"
      }
    ]
  ],
  groupBranch: [],
  groupService: null,
  sftpConfirmPayload: null,
  sftpConfirmPage: null,
  sftpConfirmSelect: []
};

const getters = {
  // authenpayment: state => state.authenpayment,
  // refreshtoken_payment: state => state.refreshtoken_payment,
  refreshtoken: state => state.refreshtoken,
  accesstoken: state => state.accesstoken,
  authen: state => state.authen,
  profile: state => state.profile,
  status: state => state.status,
  send_mail_item: state => state.send_mail_item,
  // set api key
  apikey: state => state.apikey,
  accessKey: state => state.accessKey,
  A_M_store: state => state.A_M_store,
  menu: state => state.menu,
  groupBranch: state => state.groupBranch,
  groupService: state => state.groupService,
  sftpConfirmPayload: state => state.sftpConfirmPayload,
  sftpConfirmPage: state => state.sftpConfirmPage,
  sftpConfirmSelect: state => state.sftpConfirmSelect
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js